import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'

import {useStoreContext} from '../../../contexts/store'

const Header = ({editStore}) => {
    const intl = useIntl()
    const {store} = useStoreContext()

    return (
        <Text
            as="h3"
            color="black.100"
            fontFamily="caslon"
            fontSize="14px"
            fontWeight="400"
            lineHeight="20px"
            letterSpacing="0.5px"
        >
            {store && !editStore
                ? intl.formatMessage({
                      id: 'select_store_modal.my_store',
                      defaultMessage: 'My Store'
                  })
                : intl.formatMessage({
                      id: 'select_store_modal.find_my_store',
                      defaultMessage: 'Find My Store'
                  })}
        </Text>
    )
}

Header.propTypes = {
    editStore: PropTypes.bool
}

export default Header
